export function getCsrfToken(): string {
  return document.querySelector("meta[name='csrf-token']")?.getAttribute('content') ?? '';
}
